export default __webpack_public_path__ + "static/sobol-4760370eaee8ab2a4ebac8fdc1b7c7b7.jpg";